import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import {
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core';
import ReactPlayer from 'react-player';
import uiActions from '../../redux/actions/uiActions';

const PLAYBACK_RATES = [0.5, 0.75, 1, 1.25, 1.5, 2];

const formatPlaybackRateLabel = (rate) => `${String(rate).replace('.', ',')}×`;

const useStyles = makeStyles(() => ({
  root: {
    marginBottom: '2em',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  playerWrapper: {
    position: 'relative',
    paddingTop: '56.25%',
    width: '100%',
  },
  player: {
    justifyContent: 'center !important',
    position: 'absolute',
    top: 0,
    left: '-0.55%',
    width: '100%',
    height: '100%',
  },
  speedRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '0.75em',
  },
  speedControl: {
    minWidth: 140,
  },
}));

const Player = ({ url }) => {
  const classes = useStyles();
  const [playbackRate, setPlaybackRate] = useState(1);

  return (
    <Container style={{ zIndex: 10 }} className={classes.root}>
      <div className={classes.playerWrapper}>
        <figure>
          <ReactPlayer
            url={url}
            controls
            loop
            playing
            playbackRate={playbackRate}
            width="100%"
            height="100%"
            className={classes.player}
          />
          <figcaption style={{ display: 'none' }}>
            Lecteur vidéo : présentation du contenu
          </figcaption>
        </figure>
      </div>
      <div className={classes.speedRow}>
        <FormControl
          variant="outlined"
          size="small"
          className={classes.speedControl}
        >
          <InputLabel shrink id="video-playback-speed-label">
            Playback speed
          </InputLabel>
          <Select
            labelId="video-playback-speed-label"
            id="video-playback-speed"
            value={playbackRate}
            label="Playback speed"
            onChange={(e) => setPlaybackRate(Number(e.target.value))}
            inputProps={{ 'aria-label': 'Video playback speed' }}
          >
            {PLAYBACK_RATES.map((rate) => (
              <MenuItem key={rate} value={rate}>
                {formatPlaybackRateLabel(rate)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    </Container>
  );
};

Player.propTypes = {
  url: PropTypes.string.isRequired,
};

const actionCreators = {
  changePageTitle: uiActions.changePageTitle,
};

export default connect(null, actionCreators)(Player);
